export function getSettingsTabs(t) {
    return getSettingsNavigation(t).flatMap(group => group.items);
}
export function getSettingsNavigation(t) {
    return [
        {
            title: t('settings.groups.company'),
            items: [
                { title: t('settings.tabs.issuer-data'), route: '/configuracoes', exactMatch: true },
                { title: t('settings.tabs.invoice'), route: '/configuracoes/nota-fiscal' },
                { title: t('settings.tabs.brand'), route: '/configuracoes/minha-marca' },
                { title: t('settings.tabs.interest-and-fines'), route: '/configuracoes/juros-e-multas' },
                { title: t('settings.tabs.certificate'), route: '/configuracoes/certificado' },
            ],
        },
    ];
}
